var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "downloadFileModal",
      "centered": true,
      "title": "Download Claim",
      "hide-footer": true,
      "size": "md",
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.getDownloadFiles
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table w-100"
  }, [_c('thead', {}, [_c('tr', [_c('th', {
    staticStyle: {
      "border-top": "0"
    }
  }, [_vm._v("File name")]), _c('th', {
    staticStyle: {
      "border-top": "0"
    }
  }, [_vm._v("Download")])])]), _c('tbody', _vm._l(_vm.files, function (file, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(file.filename))]), _c('td', {}, [_c('div', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "action-download",
      attrs: {
        "title": "Download"
      },
      on: {
        "click": function click($event) {
          return _vm.downloadFile(file.url);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-download"
    })])])]);
  }), 0)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }